import { EnvironmentInfo } from "core";

// Environment test agenti.
// Usare flag "--configuration=testAgenti".
// es. "ng serve --configuration=testAgenti" o "ng build q8oils --configuration=testAgenti".
export const environment: EnvironmentInfo = {
    baseApiUrl: 'https://testagenti.q8oilsitalia.it/wso2_simulator',
    clientId: 'q8dev_ciam',
    clientSecret: 'q8dev_ciam',
    ciamClientId: 'l301s7obVzqJuKI4epxQQC5PPCQa',
    ciamBaseUrl: 'https://ais-test.ciam.q8.com/ciamauthentication',
    ciamScope: 'openid internal_org_user_mgt_view internal_org_user_mgt_list internal_org_user_mgt_create nternal_org_user_mgt_update internal_org_user_mgt_delete internal_user_mgt_view internal_user_mgt_list internal_user_mgt_create internal_user_mgt_update internal_user_mgt_delete',
    
    // TODO: l'header non va hardcodato nel codice, viene consigliato di riceverlo da una chiamata backend apposita
    ciamTokenAuthHeader: 'Basic bDMwMXM3b2JWenFKdUtJNGVweFFRQzVQUENRYTphWUJLZk4xRzVIQUpmZWx6WXFKM1gycnF4bkZaM2FlVVNqWHhzVHZqbm1VYQ==',
    mapsApiKey: 'AIzaSyAml6bLEXdE7EYC0KAbpm5c_S31tQCNeFM'
};
